import React from "react";

const EmptyRow = ({height = 7}) => <div style={{height: `${height}px`}}></div>;
export default EmptyRow;
